export default __webpack_public_path__ + "static/media/782.a778dd6a.jpg";